import { useEffect, useRef } from 'react';
import { useGame } from '../context/GameContext';
import { GAME_CONFIG } from '../config/constants';

/**
 * GameEngine — invisible component that drives all game ticks.
 * Uses a ref to capture the latest actions so the interval is
 * created ONCE and never restarted on re-renders.
 */
export default function GameEngine() {
  const { actions } = useGame();

  // Keep a ref to the latest actions — interval closure reads from ref,
  // so it never goes stale and never needs to restart.
  const actionsRef = useRef(actions);
  useEffect(() => {
    actionsRef.current = actions;
  }, [actions]);

  useEffect(() => {
    const id = setInterval(() => {
      actionsRef.current.tick();
      actionsRef.current.focusTick();
      actionsRef.current.updatePlots();
    }, GAME_CONFIG.tickInterval); // 100 ms

    return () => clearInterval(id);
  }, []); // ← runs ONCE, never restarts

  return null;
}